module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe",
    attrs: {
      "id": "swipe"
    }
  }, [(_vm.noVoucher) ? _c('div', [_c('div', {
    staticClass: "swipe-voucher",
    style: ({
      marginTop: 15 + 'px',
      height: (_vm.width / 3) + 'px'
    })
  }, [_c('div', {
    staticClass: "swipe-voucher-content",
    on: {
      "click": _vm.goAddVoucher
    }
  }, [_vm._m(0)])])]) : _c('div', [_c('div', {
    staticClass: "swipe-banner",
    style: ({
      width: (_vm.width * _vm.img.length) + 'px',
      transform: ("translateX(" + _vm.translateX + "px)")
    }),
    attrs: {
      "id": "swipe-banner"
    }
  }, _vm._l((_vm.img), function(item, i) {
    return _c('div', {
      key: i,
      style: ({
        width: _vm.width + 'px'
      }),
      on: {
        "click": function($event) {
          return _vm.go(_vm.img[i].link)
        }
      }
    }, [_c('div', {
      class: _vm.img[i].src
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swipe-index"
  }, _vm._l((_vm.img), function(item, i) {
    return _c('span', {
      key: i,
      class: {
        active: (_vm.index === i)
      }
    })
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe-voucher-item"
  }, [_c('p', [_vm._v("挂号前请先办卡或绑卡")]), _vm._v(" "), _c('p', {
    staticClass: "swipe-voucher-button"
  }, [_vm._v("绑定电子健康卡")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-469267ef","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Swipe.vue
// module id = 824
// module chunks = 0